export default "__VITE_ASSET__9985de63__"